<div style="text-align: center">
  <div class="spinner-border" [ngClass]="classes" role="status" aria-hidden="true" *ngIf="isLoading && !isButton">
    <span class="sr-only">Loading...</span>
  </div>
</div>


<span class="spinner-border spinner-border-sm spinner-in-btn" [ngClass]="classes" role="status" aria-hidden="true" *ngIf="isLoading && isButton"></span>
